import moment from 'moment'
import { getBidAndBookColor, getOrderStatus, getOrderStatusColor } from './objectMapValues'
import Image from '../../assets/export'
import { atob, btoa } from 'Base64'

export const getDateFormat = (arrival) => {
  return moment((arrival.date).concat('Z')).utcOffset(arrival.offset).format('MM/DD/YYYY')
}

export const getRegularDateFormat = (date, format) => moment(date, format).format('MM/DD/YYYY')

export const getArrayTimeFormat = (date) => {
  return moment((date[0].date).concat('Z')).utcOffset(date[0].offset).format('HH:mm') + '-' + moment((date[1].date).concat('Z')).utcOffset(date[1].offset).format('HH:mm')
}

export const getTimeFormat = (arrival) => {
  return moment((arrival.date).concat('Z')).utcOffset(arrival.offset).format('HH:mm')
}

export function getMonthWeekDayFormat (date) {
  return moment(date).format('MM/DD/YYYY')
}

// Get time in HH:mm or HH:mm-HH:mm format
export const getTimeFromArrivalArrayFormat = (arrival) => {
  if (arrival[1].date) {
    return moment((arrival[0].date).concat('Z')).utcOffset(arrival[0].offset).format('HH:mm') + '-' + moment((arrival[1].date).concat('Z')).utcOffset(arrival[1].offset).format('HH:mm')
  } else {
    return moment((arrival[0].date).concat('Z')).utcOffset(arrival[0].offset).format('HH:mm')
  }
}

// Get location in city, state_code format
export const getArrivalLocation = (location) => {
  return `${location.city}, ${location.stateCode}`
}

// Parse a number to a number with coma separator
export const parseNumberWithThousandSeparator = (number) => {
  return parseFloat(number).toLocaleString('en')
}

export const getTextCapitalized = (text) => {
  let temp = ''
  text.split(' ').forEach((item) => {
    temp += ' ' + item.charAt(0).toUpperCase() + item.toLowerCase().slice(1)
  })
  return temp.length ? temp.slice(1, temp.length) : temp
}

export const getLocationFilterText = (location) => {
  if (location?.city) {
    return getTextCapitalized(location.city).concat(`, ${location.state_id || location.state_code} - ${location.country}`).trim()
  } else if (location?.state) {
    return getTextCapitalized(location.state).concat(` (${location.state_id || location.state_code}) - ${location.country}`).trim()
  }
  return null
}

// Parse a location to the text the user is going to see in the cards
export const getCardsLocationText = (location, showCountry) => {
  let locationText = '- -'
  if (location?.city) {
    locationText = getTextCapitalized(location.city).concat(`, ${location.state_id || location.state_code || location.stateCode}${showCountry ? ' - ' + location.country : ''}`).trim()
  } else if (location?.state) {
    locationText = getTextCapitalized(location.state).concat(` (${location.state_id || location.state_code || location.stateCode})${showCountry ? ' - ' + location.country : ''}`).trim()
  }
  return locationText
}

export const getCapitalizeCity = (city) => {
  let tempCity = ''
  city.split(',')[0].split(' ').forEach((item, index) => {
    tempCity += (index === 0 ? '' : ' ') + item.charAt(0).toUpperCase() + item.toLowerCase().slice(1)
  })
  return city.split(',').length > 1 ? tempCity + ',' + city.split(',')[1] : tempCity
}

// Test the event to the text the user is going to see
export const getEventAddressToShow = (event) => {
  return `${event.address} ${event.location}.`
}

// Test the event to the text the user is going to see
export const getEventLocationToShow = (event) => {
  return `${getCapitalizeCity(event.city)}, ${event.state}`
}

export function insertNewItemInAList (array, newItem, idPropName) {
  const index = array.findIndex(item => item[idPropName] === newItem[idPropName])
  const oldItem = index === -1 ? {} : array[index]
  return [
    ...array.slice(0, index === -1 ? 0 : index),
    {
      ...oldItem,
      ...newItem
    },
    ...array.slice(index === -1 ? 0 : (index + 1), array.length)
  ]
}

export const getLoadStatusData = (module, load) => {
  let status
  if (module === 'all-loads' || module === 'my-loads') {
    if (load.order_status) {
      status = {
        name: getTextCapitalized(load.order_status),
        color: getBidAndBookColor(load.order_status)
      }
    }
  } else if (module === 'assigned-orders') {
    status = {
      name: getOrderStatus(load.brokerageStatus),
      color: getOrderStatusColor(load.brokerageStatus)
    }
  } else if (module === 'offers-history') {
    const accepted = load.offer_history && load.offer_history.length &&
      load.offer_history[load.offer_history.length - 1].offering_status === 'A'
    status = {
      name: accepted ? 'Accepted' : 'Declined',
      color: accepted ? 'SECONDARY_FERN' : 'RED_ORANGE'
    }
  }
  return status
}

export const getAvatarImage = (avatar) => {
  const imageURL = avatar ? `${isBase64(avatar) ? 'data:image/png;base64, ' : ''}${avatar}`
    : null
  return imageURL || Image.defaultAvatar
}

export const isBase64 = (text) => {
  try {
    return btoa(atob(text)) === text
  } catch (err) {
    return false
  }
}

export const formatSaveStorage = ({ auth, ...currentUser }) => {
  const expiration = new Date().getTime() + (auth.expires_in * 1000)
  return {
    ...currentUser,
    auth: { ...auth, expiration }
  }
}

export const getTractorPayload = (tractor) => ({
  recurring_tractor_id: tractor.recurring_tractor_id || undefined,
  tractors_available_monday: Number(tractor.tractors_available_monday || 0),
  equipment_type_id_monday: tractor.equipment_type_id_monday ? tractor.equipment_type_id_monday.equipment_code : undefined,
  teams_monday: tractor.teams_monday ? '1' : '0',
  tractors_available_tuesday: Number(tractor.tractors_available_tuesday || 0),
  equipment_type_id_tuesday: tractor.equipment_type_id_tuesday ? tractor.equipment_type_id_tuesday.equipment_code : undefined,
  teams_tuesday: tractor.teams_tuesday ? '1' : '0',
  tractors_available_wednesday: Number(tractor.tractors_available_wednesday || 0),
  equipment_type_id_wednesday: tractor.equipment_type_id_wednesday ? tractor.equipment_type_id_wednesday.equipment_code : undefined,
  teams_wednesday: tractor.teams_wednesday ? '1' : '0',
  tractors_available_thursday: Number(tractor.tractors_available_thursday || 0),
  equipment_type_id_thursday: tractor.equipment_type_id_thursday ? tractor.equipment_type_id_thursday.equipment_code : undefined,
  teams_thursday: tractor.teams_thursday ? '1' : '0',
  tractors_available_friday: Number(tractor.tractors_available_friday || 0),
  equipment_type_id_friday: tractor.equipment_type_id_friday ? tractor.equipment_type_id_friday.equipment_code : undefined,
  teams_friday: tractor.teams_friday ? '1' : '0',
  tractors_available_saturday: Number(tractor.tractors_available_saturday || 0),
  equipment_type_id_saturday: tractor.equipment_type_id_saturday ? tractor.equipment_type_id_saturday.equipment_code : undefined,
  teams_saturday: tractor.teams_saturday ? '1' : '0',
  tractors_available_sunday: Number(tractor.tractors_available_sunday || 0),
  equipment_type_id_sunday: tractor.equipment_type_id_sunday ? tractor.equipment_type_id_sunday.equipment_code : undefined,
  teams_sunday: tractor.teams_sunday ? '1' : '0',
  contact_name: tractor.contact_name || undefined,
  contact_email: tractor.contact_email || undefined,
  contact_phone: tractor.contact_phone || undefined,
  contact_fax: tractor.contact_fax || undefined,
  origin_city: tractor.origin && tractor.origin.city ? tractor.origin.city : undefined,
  origin_state: tractor.origin && tractor.origin.state_id ? tractor.origin.state_id : undefined,
  destination_city: tractor.destination && tractor.destination.city ? tractor.destination.city : undefined,
  destination_state: tractor.destination && tractor.destination.state_id ? tractor.destination.state_id : undefined,
  start_date: tractor.start_date ? getRegularDateFormat(tractor.start_date.date) : undefined,
  end_date: tractor.end_date ? getRegularDateFormat(tractor.end_date.date) : undefined,
  comments: tractor.comments || undefined
})

export const setDriverPayload = ({
  status, name, driver_id, carrier_id, location, equipmentType,
  trailer_number, tractor_number, email, phone_number, comments
}) => {
  const payload = {
    status: status?.value || '',
    location_city: location?.city || '',
    location_state: location?.state_id || '',
    trailer_type: equipmentType?.equipment_code || '',
    carrier_id: carrier_id || '',
    trailer_number: trailer_number || '',
    tractor_number: tractor_number || '',
    email: email || '',
    phone_number: phone_number || '',
    comments: comments || '',
    name: name || ''
  }

  return driver_id ? { ...payload, driver_id } : payload
}

export const getStopIcon = (routeColor, stopNumber = null) => {
  const hasStopNumber = stopNumber || stopNumber === 0
  return `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px">
    <circle id="svgPointStop${stopNumber}" stroke="${hasStopNumber ? routeColor : 'transparent'}"
      fill="${hasStopNumber ? routeColor : 'transparent'}" cx="12" cy="12" r="12" />
    <text id="svgText" x="12" y="15" font-size="10pt" font-family="arial" font-weight="bold" text-anchor="middle" fill="#FFF" textContent="1">
      ${hasStopNumber ? String.fromCharCode(65 + stopNumber) : ''}
    </text>
  </svg>`
  // const blob = new window.Blob([svgCotnent], { type: 'image/svg+xml' })
  // return URL.createObjectURL(blob)
}

export const getTractorIcon = () => {
  return `<svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 495 433.568">
    <g id="Group_1" data-name="Group 1" transform="translate(-175 -549)">
      <path id="Exclusion_2" data-name="Exclusion 2" d="M247.5,433.568a20.165,20.165,0,0,1-8.769-2.009,19.778,19.778,0,0,1-7.257-6.027l-67.612-90.567A20.7,20.7,0,0,1,161.533,331H50A49.958,49.958,0,0,1,0,281V50A49.959,49.959,0,0,1,50,0H445a49.959,49.959,0,0,1,50,50V281a49.958,49.958,0,0,1-50,50H333.467a20.7,20.7,0,0,1-2.329,3.965l-67.612,90.567a19.777,19.777,0,0,1-7.258,6.027A20.164,20.164,0,0,1,247.5,433.568ZM234.949,224.756h61.889a28.973,28.973,0,0,0-.607,6.068,30.338,30.338,0,1,0,60.675,0,31.864,31.864,0,0,0-.607-6.068h6.673a6.075,6.075,0,0,0,6.068-6.068V186.265a24.19,24.19,0,0,0-7.091-17.141L339.766,146.94a24.275,24.275,0,0,0-17.178-7.092H308.367V103.406A12.122,12.122,0,0,0,296.232,91.27H138.476a12.122,12.122,0,0,0-12.135,12.136V230.824a30.22,30.22,0,0,0,44.136,26.967,31.105,31.105,0,0,0,10.471-8.917,30.893,30.893,0,0,0,10.471,8.931,29.845,29.845,0,0,0,13.8,3.356,30.306,30.306,0,0,0,30.337-30.337,31.781,31.781,0,0,0-.606-6.067h0Zm91.62,18.2a12.171,12.171,0,1,1,8.571-3.565A12.048,12.048,0,0,1,326.569,242.959Zm-121.351,0a12.17,12.17,0,1,1,8.57-3.565A12.049,12.049,0,0,1,205.219,242.959Zm-48.541,0a12.171,12.171,0,1,1,8.571-3.565A12.048,12.048,0,0,1,156.678,242.959Zm186.615-66.743H308.367v-18.2h14.221a6.025,6.025,0,0,1,4.285,1.783l16.419,16.418Z" transform="translate(175 549)" fill="#00ac8b"/>
      <path id="Subtraction_1" data-name="Subtraction 1" d="M326.57,261.161a30.306,30.306,0,0,1-30.337-30.337,28.981,28.981,0,0,1,.607-6.068H234.95a31.841,31.841,0,0,1,.606,6.068A30.327,30.327,0,0,1,198,260.286a29.826,29.826,0,0,1-6.577-2.481,30.9,30.9,0,0,1-10.471-8.931,31.1,31.1,0,0,1-10.471,8.916,30.284,30.284,0,0,1-44.136-26.967V103.406A12.122,12.122,0,0,1,138.476,91.27H296.232a12.122,12.122,0,0,1,12.135,12.136v36.443h14.221a24.278,24.278,0,0,1,17.178,7.092l22.185,22.184a24.194,24.194,0,0,1,7.091,17.14v32.423a6.075,6.075,0,0,1-6.068,6.068H356.3a31.841,31.841,0,0,1,.607,6.068,30.307,30.307,0,0,1-30.338,30.337Zm0-42.473a12.172,12.172,0,1,0,8.571,3.565A12.048,12.048,0,0,0,326.57,218.688Zm-121.351,0a12.172,12.172,0,1,0,8.57,3.565A12.049,12.049,0,0,0,205.219,218.688Zm-48.541,0a12.171,12.171,0,1,0,8.571,3.565A12.048,12.048,0,0,0,156.678,218.688Zm151.689-60.675h0v18.2h34.924L326.873,159.8a6.024,6.024,0,0,0-4.285-1.783Z" transform="translate(175 549)" fill="#fff"/>
    </g>
  </svg>`
}

export const removeObjectProp = prop => ({ [prop]: _, ...rest }) => rest

export const getRecurringTractorActiveDays = obj => {
  const weekDays = moment.weekdays()
  return weekDays.filter((day) => {
    const dayLowerCase = day.toLowerCase()
    const equipment = obj[`equipment_type_id_${dayLowerCase}`]
    const tractorsAvailable = obj[`tractors_available_${dayLowerCase}`]
    return equipment && equipment.equipment_code && tractorsAvailable
  })
}
